import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { CreateTransferOrderDrawer } from '../../components/create-transfer-order-drawer/create-transfer-order-drawer';
import { transferOrderGridProperties } from '../../data/transfer-order-properties';
import { useTransferOrdersGridContext } from '../../data/transfer-orders-context';
import { messages } from '../messages';
import { useDraftTransferOrderDrawer } from './use-draft-transfer-order-drawer';

import type { GridColumn } from './types';

type OrderNumberColumnProps = {
  data: Record<string, unknown>;
};

const OrderNumberColumn = ({ data }: OrderNumberColumnProps) => {
  const orderNumber = data.orderNumber as string;
  const transferOrderId = data.transferOrderId as number;
  const status = data.status as string;

  const { refreshTransferOrders } = useTransferOrdersGridContext();
  const { isLoadingDraft, draftInitialFormData, draftTransferOrderId, isDrawerOpen, closeDrawer, onClick } = useDraftTransferOrderDrawer(
    transferOrderId,
    status,
  );

  return (
    <>
      <Button disabled={isLoadingDraft} onClick={onClick} theme={THEME_CONSTANTS.link}>
        {orderNumber}
      </Button>
      {isDrawerOpen && draftInitialFormData ? (
        <CreateTransferOrderDrawer
          initialFormData={draftInitialFormData}
          onClose={closeDrawer}
          onSuccess={refreshTransferOrders}
          transferOrderId={draftTransferOrderId}
        />
      ) : null}
    </>
  );
};

export const createOrderNumberColumn = (): GridColumn => ({
  name: <FormattedMessage {...messages.orderNumberColumnHeader} />,
  render: (data) => <OrderNumberColumn data={data} />,
  id: transferOrderGridProperties.orderNumber,
});
